<template>
  <v-card>
    <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selected"
      show-select
      :headers="this.headers"
      :items="this.values"
      :search="search"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-text': 'Filas por página',
        'items-per-page-options': [20, 30, 50, 100, -1],
      }"
      :custom-filter="
        (value, search, item) =>
          dataTableCustomSearchHeaders(value, search, item, headers)
      "
    >
      <template v-slot:item.awardPropJustification.providerCompany="{ item }">
        {{
          item.awardPropJustification.providerCompany.slice(
            item.awardPropJustification.providerCompany.indexOf("-") + 1
          )
        }}
      </template>
      <template v-slot:item.awardPropJustification.amount="{ item }">
        {{ displayNewAmount(item) }}
      </template>
      <template v-slot:item.newAmount="{ item }">
        <span v-if="item.acceptedNewAmount !== 0">
          SI {{ formatAmount(item.acceptedNewAmount) }}</span
        >
        <span v-else> NO </span>
      </template>
      <template
        v-slot:item.awardPropJustification.remainingProjectAmount="{ item }"
      >
        {{
          getDegreeOfExecution(item) === "NaN"
            ? "0.00"
            : getDegreeOfExecution(item)
        }}
        %
      </template>
      <template v-slot:item.degreeOfExecution="{ item }">
        {{ item.degreeOfExecution }}
        %
      </template>
      <template v-slot:item.cuentasContables.postedInvoice="{ item }">
        <v-icon v-if="!item.cuentasContables.postedInvoice" color="error"
          >mdi-checkbox-blank-circle-outline</v-icon
        >
        <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
      </template>
      <template v-slot:item.offerFile="{ item }">
        <div class="d-flex clickable" @click="openPdfPreview(item.offerFile)">
          <span class="d-inline-block text-truncate" style="max-width: 150px"
            >{{ item.offerFileName }}
          </span>
          <v-icon> mdi-text-box-search</v-icon>
        </div>
      </template>
      <template v-slot:item.awardPropJustification.contractFile="{ item }">
        <div
          class="d-flex clickable"
          @click="openPdfPreview(item.awardPropJustification.contractFile)"
        >
          <span class="d-inline-block text-truncate" style="max-width: 150px">{{
            item.awardPropJustification.contractFileName
          }}</span>
          <v-icon> mdi-text-box-search</v-icon>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          x-small
          color="primary"
          :to="
            `/${getPath(item.typeOfPurchase)}/${item.typeOfPurchase}/` + item.id
          "
          target="_blank"
        >
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          x-small
          color="error"
          @click="confirmDeleteItem(item)"
          v-if="
            getCanDelete ||
            (item && getUserData && item.promoter === getUserData.id)
          "
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <PreviewPdf :isDialog="dialog" :url="url" @closeDialog="closePdfPreview" />
    <v-row justify="center">
      <v-dialog v-model="dialogConfrim" persistent max-width="390">
        <v-card>
          <v-card-title class="text-h6" style="word-break: break-word">
            ¿Está seguro que quiere eliminar el expediente?
          </v-card-title>
          <v-card-text>
            <p>El grado de ejecución es del {{ degreeOfExecution }}</p>
            <p v-if="hasInvoices">
              Para poder eliminar el expediente, antes debe eliminar las
              facturas asociadas.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogConfrim = false">
              Cancelar
            </v-btn>
            <v-btn
              :disabled="hasInvoices"
              color="red darken-1"
              text
              @click="deleteContract(selectedContradtId)"
            >
              Si
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      v-if="selected.length"
      v-model="selected"
      :timeout="-1"
      color="primary"
    >
      Exportar {{ selected.length }} elementos
      <v-btn
        color="secondary"
        @click.native="exportToCSV(selected, 'data.csv', headers)"
        >Descargar</v-btn
      >
    </v-snackbar>
  </v-card>
</template>

<script>
import formatters from "@/utils/formatters.js";
import PreviewPdf from "@/components/PreviewPdf.vue";
import services from "@/services/services";
import Snackbar from "@/components/Snackbar";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ContractsTable",
  props: ["headers", "values"],
  components: {
    Snackbar,
    PreviewPdf,
  },
  data() {
    return {
      selected: [],
      search: "",
      textError: null,
      isSnackbar: false,
      dialog: false,
      url: "",
      dialogConfrim: false,
      degreeOfExecution: null,
      hasInvoices: null,
      selectedContradtId: null,
    };
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    getPromoter(id) {
      let promoter = this.getObjectById("users", id);
      return promoter ? `${promoter.name} ${promoter.surname}` : "";
    },

    // customSearch(value, search, item) {
    //   // return Object.values(item).some(
    //   //   (v) => v && v.toString().toLowerCase().includes(search.toLowerCase())
    //   // );
    //   return (
    //     item.searchFieldsText &&
    //     item.searchFieldsText.toLowerCase().includes(search.toLowerCase())
    //   );
    // },
    formatAmount(amount) {
      return formatters.amountFormatter.format(Number(amount));
    },
    deleteContract(id) {
      this.setActionsLoader(true);
      services
        .deleteData("contracts", id)
        .then(() => {
          this.setActionsLoader(false);
          this.textError = null;
          this.isSnackbar = true;
          this.dialogConfrim = false;
        })
        .catch((e) => {
          console.error(e);
          this.setActionsLoader(false);
          this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
          this.isSnackbar = true;
          this.dialogConfrim = false;
        });
    },
    confirmDeleteItem(item) {
      this.dialogConfrim = true;
      this.selectedContradtId = item.id;
      this.degreeOfExecution = `${
        this.getDegreeOfExecution(item) === "NaN"
          ? "0.00"
          : this.getDegreeOfExecution(item)
      }%`;
      this.hasInvoices = this.degreeOfExecution !== "0.00%";
    },
    openPdfPreview(url) {
      this.url = url;
      this.dialog = true;
    },
    closePdfPreview() {
      this.dialog = false;
    },
    getPath(type) {
      if (type === "Marco") {
        return "cecontract";
      } else {
        return "cecontract";
      }
    },
    getDegreeOfExecution(item) {
      if (item.typeOfPurchase === "Marco") {
        //OLD
        //   let ccFrame = this.getCCframes?.find(ccframe => ccframe.marcoId === item.id);
        //   let total = ccFrame?.totalAmount - ccFrame?.remainingAmount;
        //   return (
        //   (1 -
        //     parseFloat(item.awardPropJustification.remainingProjectAmount) /
        //       parseFloat(total)) *
        //   100
        // ).toFixed(2);
        //OLD
        let invTotal = 0;
        this.getInvoices.forEach((inv) => {
          if (inv.associatedFile === item.id) {
            invTotal += inv.taxBase;
          }
        });
        let existAcceptedNewAmount = item.acceptedNewAmount
          ? item.acceptedNewAmount
          : false;
        let amount =
          existAcceptedNewAmount && item.acceptedNewAmount !== 0
            ? item.acceptedNewAmount
            : item.awardPropJustification.amount;
        return ((parseFloat(invTotal) / parseFloat(amount)) * 100).toFixed(2);
      } else {
        let existAcceptedNewAmount = item.acceptedNewAmount
          ? item.acceptedNewAmount
          : false;
        let amount =
          existAcceptedNewAmount && item.acceptedNewAmount !== 0
            ? item.acceptedNewAmount
            : item.awardPropJustification.amount;
        return (
          (1 -
            parseFloat(item.awardPropJustification.remainingProjectAmount) /
              parseFloat(amount)) *
          100
        ).toFixed(2);
      }
    },
    displayNewAmount(item) {
      let existAcceptedNewAmount = item.acceptedNewAmount
        ? item.acceptedNewAmount
        : false;
      return existAcceptedNewAmount && item.acceptedNewAmount !== 0
        ? this.formatAmount(item.acceptedNewAmount)
        : this.formatAmount(item.awardPropJustification.amount);
    },
  },
  computed: {
    ...mapGetters([
      "getObjectById",
      "getCanDelete",
      "getUserData",
      "getInvoices",
    ]),
  },
};
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>
